import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

const updateCampaignDeliverabilityStatusGQL = ({ id, status }) => {
  const query = `
    mutation updateStatusCampaignDeliverability($input: UpdateStatusCampaignDeliverabilityInput!){
          updateStatusCampaignDeliverability(input: $input){
                  id
                  status
         }
      }
  `
  const params = {
    input: {
      id,
      status,
    },
  }

  return callAuthorizedGraphQLEndpoint(query, params)
}

const getCampaignsDeliverabilityStatus = campaignId => {
  const query = `
    query ($campaignId:ID!) {
      campaign(id:$campaignId) {
        deliverabilityReport {
          id
          status
        }
      }
    }
  `
  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

export {
  updateCampaignDeliverabilityStatusGQL,
  getCampaignsDeliverabilityStatus,
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignTimeline/gql.js